import React from 'react';
import {observer} from 'mobx-react';
import {EmployeeNameWithAvatar} from 'components';

const EmployeeNameCell = observer(({model}) => {
  return <EmployeeNameWithAvatar employee={model.employee}/>;
});

export default EmployeeNameCell;
